(function ($, njm) {
    'use strict';

    njm.views.subscribe = Backbone.View.extend({

        events: {
            'keyup #subscribeInput': 'validate',
            'click #subscribeButton': 'submit'
        },

        /**
         * Initialize
         */
        initialize: function () {
            this.$input = this.$('#subscribeInput');
            this.$button = this.$('#subscribeButton');
            this.$errorMsg = this.$('.msg-error');

            this.$button.prop('disabled', true);
            this.$errorMsg.hide();
        },

        /**
         * Validate
         */
        validate: function (e) {
            if ($(e.currentTarget).val() === '') {
                this.$button.prop('disabled', true);
            } else {
                this.$button.prop('disabled', false);
            }
        },

        /**
         * Submit
         */
        submit: function (e) {
            this.minChar = 7;
            this.maxChar = 60;
            this.reg = /.+\@.+\..+/;

            this.$errorMsg.hide();

            if ((this.$input.val().length < this.minChar) || (this.$input.val().length > this.maxChar) || (!this.reg.test(this.$input.val()))) {
                $('.msg-error').show();

                return false;
            }
        }

    });
})(jQuery, njm);
